import clsx from 'clsx';

import styles from './ModalContentsContainer.module.scss';

const ModalContentsContainer = ({
  children,
  gap = 12,
  className,
}: {
  children: React.ReactNode;
  gap?: number;
  className?: string;
}) => {
  return (
    <div
      className={clsx(styles['modal-contents-container'], className)}
      style={{ '--gap': `${gap}px` } as React.CSSProperties}
    >
      {children}
    </div>
  );
};

export default ModalContentsContainer;
